// ====================
// components/ExperienceSection.js
// ====================

import React from 'react';

const ExperienceSection = () => {
  const experiences = [
    {
      date: 'May 2025 - Present',
      title: 'IT Analyst',
      company: 'Leahy Center for Digital Forensics and Cybersecurity | Champlain College',
      tasks: [
        'Respond to client tickets in a professional and timely manner',
        'Reimage client machines manually or with FOG server',
        'Collaborate with clients\' preexisting IT departments',
        'Provide technical support for cybersecurity and digital forensics tools'
      ]
    },
    {
      date: 'May 2023 - August 2023',
      title: 'Research Assistant | IoT Extraction',
      company: 'Leahy Center for Digital Forensics and Cybersecurity | Champlain College',
      tasks: [
        'Assisted in writing backend code for a device file extractor',
        'Participated in Agile development practices including Scrums',
        'Collaborated on project planning and future development strategies',
        'Contributed to research in IoT device forensics and data extraction'
      ]
    },
    {
      date: 'February 2023 - Present',
      title: 'Produce Teammate',
      company: 'Market 32, Burlington, VT',
      tasks: [
        'Train new produce teammates, developing leadership and communication skills',
        'Perform detailed closing tasks including inventory management and organization',
        'Handle product markdowns and pricing adjustments',
        'Maintain quality standards and customer service excellence'
      ]
    }
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <h2>Professional Experience</h2>
        
        <div className="experience-timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="experience-item">
              <div className="experience-date">{exp.date}</div>
              <div className="experience-content">
                <h3>{exp.title}</h3>
                <h4>{exp.company}</h4>
                <ul className="experience-list">
                  {exp.tasks.map((task, taskIndex) => (
                    <li key={taskIndex}>{task}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;